import ApplyCoupon from '@anm/components/form/ApplyCoupon';
import { FC } from 'react';

import EditCardBlock from '../EditCardBlock';

export type CouponEditCardBlockProps = { onCouponApply: () => void };

const CouponEditCardBlock: FC<CouponEditCardBlockProps> = ({
  onCouponApply
}) => (
  <EditCardBlock additionalField={<ApplyCoupon onApply={onCouponApply} />} />
);

export default CouponEditCardBlock;
